let resolvers = {};

export const registerResolver = (id, resolve) => {
    resolvers[id] = resolve;
};

export const resolveModal = (id, value) => {
    if (resolvers[id]) {
        resolvers[id](value);
        delete resolvers[id];
    }
};